export const CUSTOMERS_SET_DATA_BEGIN = 'CUSTOMERS_SET_DATA_BEGIN';
export const CUSTOMERS_SET_DATA_SUCCESS = 'CUSTOMERS_SET_DATA_SUCCESS';
export const CUSTOMERS_SET_DATA_FAIL = 'CUSTOMERS_SET_DATA_FAIL';
export const CUSTOMERS_REDIRECTION = 'CUSTOMERS_REDIRECTION';
